/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { type Routes, RouterModule } from '@angular/router';
import { CoreModule } from '@dm/core';

import { DMCommonModule } from '../../../common/dm-common.module';
import { PoweronFailComponent } from './poweron-fail.component';
import { PoweronFailService } from './poweron-fail.service';

const routers: Routes = [{
    path: '',
    component: PoweronFailComponent,
}];

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        RouterModule.forChild(routers),
        ReactiveFormsModule,
        CoreModule,
        DMCommonModule,
    ],
    declarations: [
        PoweronFailComponent,
    ],
    providers: [PoweronFailService],
})
export class PoweronFailModule { }
